module.exports = __webpack_public_path__ + "static/media/skill.6997670d.svg";